<template>
    <div id="app" :style="conheight">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
      data() {
        return {
          conheight: {height: ''} //   页面高度
        };
      },
      methods: {
        getHeight() {
          this.conheight.height = window.innerHeight + 'px';
        },
      },
      created() {
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
      },
      computed: {
        closingPage() {
          return this.$store.state.closingPage
        },
      },
    }
</script>
<style></style>


